var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99996 8.83398C2.4602 8.83398 2.83329 8.46089 2.83329 8.00065C2.83329 7.54041 2.4602 7.16732 1.99996 7.16732C1.53972 7.16732 1.16663 7.54041 1.16663 8.00065C1.16663 8.46089 1.53972 8.83398 1.99996 8.83398Z",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99996 3.00065C2.4602 3.00065 2.83329 2.62755 2.83329 2.16732C2.83329 1.70708 2.4602 1.33398 1.99996 1.33398C1.53972 1.33398 1.16663 1.70708 1.16663 2.16732C1.16663 2.62755 1.53972 3.00065 1.99996 3.00065Z",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99996 14.6673C2.4602 14.6673 2.83329 14.2942 2.83329 13.834C2.83329 13.3737 2.4602 13.0007 1.99996 13.0007C1.53972 13.0007 1.16663 13.3737 1.16663 13.834C1.16663 14.2942 1.53972 14.6673 1.99996 14.6673Z",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.94b1487d0bafe5dbdbdadfe05c8e1c20.svg";
export { ForwardRef as ReactComponent };